import { apiAgent } from "../../../../axiosConfig";

export const fetchAccessRoles = () =>
    apiAgent({
        method: "get",
        url: "/team/access_roles",
        params: {},
    }).then((response) => response.data);

export const fetchAssignableRoles = () =>
    apiAgent({
        method: "get",
        url: "/team_members/role_options",
        params: {},
    }).then((response) => response.data);

export const createAccessRole = (role) =>
    apiAgent({
        method: "post",
        url: "/team/access_roles",
        data: role,
    }).then((response) => response.data);

export const previewAccessRole = (roleId, permissionKeys) =>
    apiAgent({
        method: "post",
        url: "/team/access_roles/" + roleId + "/preview",
        data: { permission_keys: permissionKeys },
    }).then((response) => response.data);

export const updateAccessRole = (roleId, role) =>
    apiAgent({
        method: "post",
        url: "/team/access_roles/" + roleId + "/update",
        data: role,
    }).then((response) => response.data);

export const deleteAccessRole = (roleId, replacementRoleId, lockVersion) =>
    apiAgent({
        method: "post",
        url: "/team/access_roles/" + roleId + "/delete",
        data: {
            replacement_role_id: replacementRoleId || null,
            lock_version: lockVersion,
        },
    }).then((response) => response.data);

export const updateMemberAccess = (memberId, access) =>
    apiAgent({
        method: "post",
        url: "/team_members/" + memberId + "/update_access",
        data: access,
    }).then((response) => response.data);
